import { createStandaloneToast } from '@chakra-ui/react'
const toast = createStandaloneToast()

// const STATUSES = ['success', 'error', 'warning', 'info']
function NotificationToast(type, title, description) {
  toast({
    position: 'top',
    title: title,
    description: description,
    status: type,
    duration: 5000,
    isClosable: true
  })
}

export default NotificationToast
